import { useModalStore } from "@/stores/modals/modals.store";

// A PDF needs almost the whole window to be readable, so every caller opens FileModal in the same
// oversized dialog. Kept in one place because the viewer is opened from four unrelated screens
// (library detail, library card, create/edit material, material database) and a dialog that is only
// large on some of them is how the viewer ended up hard to close in the first place.
// `w-full max-w-none` rather than a viewport width: ModalRoot centres the dialog inside a `p-4`
// gutter, so a 95vw box would be wider than the space it is given and get shrunk back by the flex
// container anyway. `min-h-0` drops ModalRoot's 460px floor, which on a short window would otherwise
// push the dialog taller than the viewport.
const FILE_MODAL_WRAPPER_CLASS = "h-[92dvh] max-h-[92dvh] w-full max-w-none min-h-0";

/**
 * Opens the EPD/PDF viewer for a stored file. Always stackable: the viewer is opened from on top of
 * another modal (the mapping modal, the library detail pane), and a non-stackable open replaces the
 * whole stack, destroying the modal the user came from.
 */
export const openFileModal = (fileId: string) =>
  useModalStore().open(
    "FileModal",
    { fileId },
    {
      stackable: true,
      wrapperClass: FILE_MODAL_WRAPPER_CLASS,
      ariaLabel: "EPD document",
    }
  );
